import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  const quickLinks = [
    { path: '/home', label: 'Home' },
    { path: '/brands', label: 'Brands' },
    { path: '/category', label: 'Categories' },
    { path: '/contact', label: 'Contact' },
  ]

  return (
    <footer className='modern-footer'>
      {/* Main Footer Content */}
      <div className='footer-main'>
        <div className='footer-container'>
          <div className='footer-grid'>
            
            {/* Brand Section */}
            <div className='footer-brand-section'>
              <Link to="/" className='footer-logo'>
                <img src="/logo.png" alt="Planet Music" />
              </Link>
              <p className='footer-tagline'>
                Your trusted destination for quality musical instruments. 
                Bringing melodies to life since establishment.
              </p>
              <div className='footer-social'>
                <a 
                  href='https://www.facebook.com/profile.php?id=100064544566071' 
                  target='_blank' 
                  rel='noopener noreferrer'
                  className='social-link'
                  aria-label='Facebook'
                >
                  <i className="fa-brands fa-facebook-f"></i>
                </a>
                <a 
                  href='https://www.instagram.com/planetmusic.np/' 
                  target='_blank' 
                  rel='noopener noreferrer'
                  className='social-link'
                  aria-label='Instagram'
                >
                  <i className="fa-brands fa-instagram"></i>
                </a>
                <a 
                  href='https://www.youtube.com/@planetmusicnepal1650' 
                  target='_blank' 
                  rel='noopener noreferrer'
                  className='social-link'
                  aria-label='YouTube'
                >
                  <i className="fa-brands fa-youtube"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className='footer-links-section'>
              <h4 className='footer-heading'>Quick Links</h4>
              <ul className='footer-links'>
                {quickLinks.map(link => (
                  <li key={link.path}>
                    <Link to={link.path} className='footer-link'>
                      <i className="fa-solid fa-chevron-right"></i>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div className='footer-contact-section'>
              <h4 className='footer-heading'>Get In Touch</h4>
              <div className='footer-contact-list'>
                <a href="mailto:planetmusicktm@gmail.com" className='footer-contact-item'>
                  <div className='contact-icon'>
                    <i className='fa-solid fa-envelope'></i>
                  </div>
                  <div className='contact-text'>
                    <span className='contact-label'>Email Us</span>
                    <span className='contact-value'>planetmusicktm@gmail.com</span>
                  </div>
                </a>
                <a href="tel:+9779801053815" className='footer-contact-item'>
                  <div className='contact-icon'>
                    <i className='fa-solid fa-phone'></i>
                  </div>
                  <div className='contact-text'>
                    <span className='contact-label'>Call Us</span>
                    <span className='contact-value'>+977 9801053815</span>
                  </div>
                </a>
                <a
                  href="https://wa.me/9779801053815"
                  target='_blank'
                  rel='noopener noreferrer'
                  className='footer-contact-item'
                >
                  <div className='contact-icon'>
                    <i className='fa-brands fa-whatsapp'></i>
                  </div>
                  <div className='contact-text'>
                    <span className='contact-label'>WhatsApp Us</span>
                    <span className='contact-value'>+977 9801053815</span>
                  </div>
                </a>
                <div className='footer-contact-item'>
                  <div className='contact-icon'>
                    <i className='fa-solid fa-location-dot'></i>
                  </div>
                  <div className='contact-text'>
                    <span className='contact-label'>Visit Us</span>
                    <span className='contact-value'>Thimi, Bhaktapur, Nepal</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Newsletter / CTA Section */}
            <div className='footer-cta-section'>
              <h4 className='footer-heading'>Stay Connected</h4>
              <p className='footer-cta-text'>
                Visit our store to explore our full collection of musical instruments.
              </p>
              <Link to="/contact" className='footer-cta-btn'>
                <i className="fa-solid fa-music"></i>
                <span>Contact Us</span>
              </Link>
            </div>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className='footer-bottom'>
        <div className='footer-container'>
          <div className='footer-bottom-content'>
            <p className='copyright'>
              © {currentYear} <span>Planet Music</span>. All rights reserved.
            </p>
            <p className='footer-credit'>
              Made with <i className="fa-solid fa-heart"></i> for musicians
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
